import { capitalize, dayjs } from '@tunasong/models'
import { getPlugin, usePlugins } from '@tunasong/plugin-lib'
import type { SidebarComponent } from '@tunasong/ui-lib'
import { Divider, ElementForm, HBox, Typography } from '@tunasong/ui-lib'
import type { FC } from 'react'
import styles from './sidebar-settings.module.css'

export const SidebarSettings: FC<SidebarComponent> = ({ entity, onEntityChange }) => {
  const plugins = usePlugins('all')
  const EntityProperties = entity ? getPlugin(entity, plugins)?.components?.Properties : null

  return (
    <div className={styles.root} key={entity.id}>
      <ElementForm element={entity} onChange={onEntityChange} />
      {EntityProperties ? (
        <>
          <Divider className={styles.divider}>
            <Typography variant="caption">{capitalize(entity.type)} properties</Typography>
          </Divider>
          <EntityProperties key={entity.id} element={entity} onChange={onEntityChange} />
        </>
      ) : null}
      <Divider className={styles.divider} />
      <div className={styles.metaSection}>
        <HBox className={styles.metaRow}>
          <Typography variant="caption">Created</Typography>
          <Typography variant="caption"> {dayjs(entity.createdAt).format('LL')}</Typography>
        </HBox>
        <HBox className={styles.metaRow}>
          <Typography variant="caption">Last updated</Typography>
          <Typography variant="caption">{dayjs(entity.updatedAt).format('LL')}</Typography>
        </HBox>
      </div>
    </div>
  )
}
